import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { firstValueFrom, forkJoin } from 'rxjs';
import { ContentService } from 'src/app/core/services/common/content.service';
import { PageStateService } from 'src/app/core/services/onboarding/page-state.service';

@Injectable({
  providedIn: 'root',
})
export class PageStateClientAdditionalInfoRequestPersonalizedResolver
  implements Resolve<boolean>
{
  constructor(private ps: PageStateService, private cs: ContentService) {}
  async resolve(route: ActivatedRouteSnapshot): Promise<any> {
    const { stateId } = route.queryParams;
    return firstValueFrom(
      forkJoin({
        transitions: this.ps.getPageTransitionsByStateId(stateId ?? '0'),
        contentDict:
          this.cs.getContentDictByStateId_ClientAdditionalInfoRequestPageContent(
            stateId ?? '0'
          ),
      })
    );
  }
}
